var map = {
	"./famouspersons/caregiver.png": 5013,
	"./famouspersons/creator.png": 6829,
	"./famouspersons/everyman.png": 9606,
	"./famouspersons/explorer.png": 10,
	"./famouspersons/hero.png": 2752,
	"./famouspersons/innocent.png": 7184,
	"./famouspersons/jester.png": 3988,
	"./famouspersons/lover.png": 9188,
	"./famouspersons/magician.png": 6409,
	"./famouspersons/outlaw.png": 8217,
	"./famouspersons/ruler.png": 3053,
	"./famouspersons/sage.png": 7400
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5303;